/**
 * computeMaterialTotals.ts — material BOM aggregation (MAT-02).
 *
 * ROUNDING RULE (Polish kosztorys parity with computeTotals.ts):
 *   - lineTotal is already rounded to 2dp by buildBOM.
 *   - netTotal = sum of already-rounded lineTotals — DO NOT roundTo the sum.
 *   - This is identical to the labour discipline in computeTotals.ts line 143:
 *     "netTotal is the sum of already-rounded line totals — no further rounding"
 *
 * ЗАПРЕЩЕНО: toFixed / Math.round прямо — только roundTo из shared/lib/number.
 * lineTotal already rounded in buildBOM to 2dp.
 * Display with .toFixed(2) ONLY — NEVER re-round in PDF/Excel/UI consumers.
 */

import type { BOMLine, BOMTotalsResult } from '../model/types';

/**
 * Aggregates BOM lines into a totals result.
 *
 * netTotal is the sum of already-rounded lineTotals.
 * Do NOT call roundTo(netTotal, ...) — sum of pre-rounded values is canonical
 * (same rule as labour netTotal in EstimateTotalsResult).
 */
export function computeMaterialTotals(lines: BOMLine[]): BOMTotalsResult {
  // Sum of already-rounded lineTotals — parity with computeEstimateTotals line 143
  const netTotal = lines.reduce((sum, l) => sum + l.lineTotal, 0);
  return { lines, netTotal };
}
